import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from 'src/app/services/interface';
import { ServiceFormService } from '../service-form.service';

@Component({
  selector: 'app-service-scoping',
  templateUrl: './service-scoping.component.html',
  styleUrls: ['./service-scoping.component.scss']
})
export class ServiceScopingComponent implements OnInit {
  public service: Service;

  constructor(
    private route: ActivatedRoute,
    private serviceFormService: ServiceFormService,
  ) { }

  ngOnInit(): void {
    this.route.parent.data.subscribe(data => {
      this.service = data.serviceDetails;
    })
  }
  public get serviceFormGroup() {
    return this.serviceFormService.serviceFormGroup
  }

  public get regionScopingForm() {
    return this.serviceFormService.regionScopingForm
  }

  public get regionScoping() {
    return this.regionScopingForm.value
  }

  public removeRegion(index: number) {
    const values: [] = this.regionScopingForm.value;
    this.regionScopingForm.patchValue(values.filter((_, i) => i !== index));
  }
}
